import { render, staticRenderFns } from "./epfoFormView.vue?vue&type=template&id=69ba823c&"
import script from "./epfoFormView.vue?vue&type=script&lang=js&"
export * from "./epfoFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports